<template>
  <section
    class="section  AboutMe has-background-black-bis "
    id="AboutMe">

    <div class="timeline-container aboutMargin">

    <div class="timeline">
      <header class="timeline-header">
        <span class="tag is-medium is-info" style="background-color: #6b31d9; font-weight: 1000;">1995</span>
      </header>

      <div class="timeline-item">                                                                   
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="one" style="display: flex; justify-content: center; align-items: center;">
                <div style="width: auto;">
                  <img style=" margin: auto;" id="grayscale" class="imgIcon" src="../assets/aboutMe.svg" />
                </div>
              </div>

                <h1 class="title"><strong style="color: #efefef ;">About Me</strong></h1>
                  <p>
                    Hello, I'm Davey Hurkmans. At Fontys ICT, I honed my skills as a UX Designer and Developer. My interests span User Interfaces, Web Development, Blender, and Unity. During my time at Fontys, I explored various programming languages like JavaScript/TypeScript, C# (Unity), Java (Android Studio), and Python.
                  </p> <br/>
                  <p>
                    Design has always been a passion, and I've become proficient with tools like Adobe Creative Cloud, Blender, Invision, and Sketch. Joining the "Fontys Excellence Program" known as DELTA allowed me to deepen my knowledge and collaborate with motivated peers, exploring topics like Hardware, Media Design, and Software projects.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="timeline-header">
        <span class="tag is-info" style="background-color: #6b31d9; font-weight: 1000;">2012</span>
      </header>

      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="two" style="display: flex; justify-content: center; align-items: center;">       
                  <img id="grayscale" class="imgIcon"
                    src="../assets/summa.png"
                  />
                </div>

                <h1 class="title"><strong style="color: #efefef ;">MBO "Summa College" IT & Networking (Levels 3 & 4)</strong></h1>
                <p>
                  I completed the Level 3 course in three years and fast-tracked through Level 4 in just one year. Along the way, I gained skills in HTML, CSS, PHP, databases, IT helpdesk support, creating enterprise networks within the Microsoft ecosystem, Linux, IP calculations, IT, and networking.
                  <br><br>
                  I also completed internships at Valkenhof, Valkenswaard City Hall (Gemeente Valkenswaard), Fontys Eindhoven, and RIVA-IT, all of which enriched my IT networking and helpdesk experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
     

      <header class="timeline-header">
        <span class="tag is-info" style="background-color: #6b31d9; font-weight: 1000;">2017</span>
      </header>

      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="three" style="display: flex; justify-content: center; align-items: center;">
                  <img class="imgIcon" src="../assets/fontys.png" alt="" />
                </div>


                <h1 class="title"><strong style="color: #efefef ;"> Fontys HBO ICT </strong></h1>

                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">Fontys HBO ICT Profile</strong></h1>
                <p>
                  In my first year at Fontys, I explored all the profiles offered, including Media Design (covering web development and programming), Software (with a focus on C#), Hardware (involving Mindstorm EV3 and Arduino), and Business (featuring Excel and dashboarding).
                </p>
                <br> <br>
                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">DELTA / Media Design / Smart Mobile (Year 2)</strong></h1>
                <p>
                  In this phase, I delved into projects such as "Feel The Spark" at Glow 2018, which involved creating an interactive light installation. I also developed an Android app for diabetes monitoring and a smart mirror project using frontend technologies and Python.
                </p>
                <br> <br>
                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">Internship at Greenhouse Group (Year 3)</strong></h1>
                <p>
                  I worked on projects related to Solid (Social Linked Data) and web 3 technologies, creating prototypes for a decentralized blog, messaging app, and ad-picker based on IBM categories. This experience expanded my knowledge of React and Solid web 3.0 technologies.
                </p>
                <br> <br>
                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">DELTA / Media Design / Open Innovation (Year 3)</strong></h1>
                <p>
                  During this year, I focused on concept creation and physical installations for events like Glow. Projects included "Frightened Flowers," featuring intricate LED light effects, and "Friendly Robot," an interactive module using AI and facial recognition.
                </p>
                <br> <br>
                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">Minor - Open Innovation (Year 4)</strong></h1>
                <p>
                  I participated in the Open Innovation minor, which included projects like "Smart City Light" for Glow 2020, where we collaborated with a light artist to create energy-efficient, customizable street lights. Another project involved creating a web-based mini-games platform for Paaspop 2020.
                </p>
                <br> <br>
                <h1 style=" margin-bottom:  0.5vw;"><strong class="miniTitle" style="color: #efefef;">Internship at Philips Design (Year 4)</strong></h1>
                <p>
                  My graduation internship involved working on the xrDLS (Extended Reality Design Language System) project. I contributed to UX/UI design and development, creating 3D-styled objects for AR and VR applications using the Microsoft Mixed Reality Toolkit (MRTK).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <header class="timeline-header">
        <span class="tag is-info" id="WorkExperience" style="background-color: #6b31d9; font-weight: 1000;">2021</span>
      </header>

      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="four" style="display: flex; justify-content: center; align-items: center;">
                  <img class="imgIcon" id="grayscale"
                    src="../assets/company1.png"
                  />
                </div>

                <h1 class="title"><strong style="color: #efefef ;">Work Experience @Philips-Design</strong></h1>
                <p>
                  I also gained valuable work experience at Philips Research, where I contributed to the "R2PM" project by designing a patient management dashboard. At Philips Design, I worked on the "Eagle.ai" project, enhancing the user experience of AI-driven applications for medical professionals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="timeline-header">
        <span class="tag is-info" id="WorkExperience" style="background-color: #6b31d9; font-weight: 1000;">2023</span>
      </header>

      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="five" style="display: flex; justify-content: center; align-items: center;">
                  <img class="imgIcon"
                    src="../assets/MH.png"
                  />
                </div>

                <h1 class="title"> <strong style="color: #efefef ;">Work Experience @MechHive</strong></h1>
                <p>
                  During my short time at MechHive, I was part of a transformative journey in the world of digital gifting. MechHive, a dynamic gift card seller startup, provided a platform for me to contribute to pioneering changes in the online gift card industry.
                  <br> <br>
                  My primary role at MechHive centered on crafting user-centered digital platforms. These platforms were designed to offer users intuitive and visually appealing interfaces, revolutionizing the way individuals engage with digital gift cards.
                  <br> <br>
                  A significant milestone during my time at MechHive was our mission to introduce multiple services aimed at reshaping the gift card landscape. My primary focus revolved around developing user-friendly interfaces that promised to redefine the gifting experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="timeline-header">
        <span class="tag is-info" id="WorkExperience" style="background-color: #6b31d9; font-weight: 1000;">2024</span>
      </header>

      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="eleven" style="display: flex; justify-content: center; align-items: center;">
                  <img class="imgIcon" style="height: auto; width: 30%;"
                    src="../assets/wf.png"
                  />
                </div>

                <h1 class="title"> <strong style="color: #efefef;">Work Experience @WeFact</strong></h1>
                <p>
                  At WeFact I had the pleasure to work on a varied range of tasks, as a main focus my job was front-end development and working on improvements to our SaaS application. This could range between working on our main web application (MijnWeFact), working on the corporate website or updating our React app that connects the main application via the API.
                  <br> <br>
                  Together with my colleague we build a new corporate website (ReactJS, Apollo and NextJS and Tailwind css) which made it possible for our sales team to make changes to the website with the help of a chosen CMS system. It was possible to create new pages from certain templates, together with our customizable components it is really easy to create stunning webpages within the WeFact branding.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header class="timeline-header">
        <span class="tag is-medium is-info" style="background-color: #7f52d1; font-weight: 1000;">Now</span>
      </header>


      <div class="timeline-item">
        <div class="timeline-content">
          <div class="tl-item about">
            <div class="columns">
              <div class="column is-two-third about">
                <div class="topImgBox" id="six" style="display: flex; justify-content: center; align-items: center;">
                  <img class="imgIcon"
                    src="../assets/hireMe.svg"
                  />
                </div>
                <h1 class="title"><strong style="color: #efefef;">Hire Me as a UX/UI Designer</strong></h1>
                <p>
                  Hello, my name is Davey Hurkmans, and during my time at Fontys ICT, I developed my skills as a UX Designer and Developer. My journey began with a curiosity for web development and creating captivating, stylish web pages. As I delved deeper into my studies, my interests expanded, encompassing various facets of user interfaces, web development, Blender, and Unity development. <br> <br>
                  I also gained valuable work experience at Philips Research, where I contributed to the "R2PM" project by designing a patient management dashboard. At Philips Design, I worked on the "Eagle.ai" project, enhancing the user experience of AI-driven applications for medical professionals. Additionally, I've recently acquired expertise in designing for e-commerce and webshops. <br> <br>
                  Now, I find myself based in the vibrant Eindhoven area in the Netherlands, eagerly seeking new opportunities as a UX/UI Designer and Researcher. My enthusiasm knows no bounds, whether it's working on-site or remotely. I'm dedicated to crafting user-centric designs that not only inspire but also deliver tangible results. If you're in search of a passionate designer with a unique blend of creativity and technical expertise, I'm poised and ready to contribute my skills to your team. Together, let's embark on a journey to make your next project a resounding success!                
                </p>
              </div>
            </div>
          </div>  
        </div>
      </div>

      <header class="timeline-header">
        <span class="tag endtag is-medium is-info" style="background-color: #7f52d1; font-weight: 1000;">Thanks for reading!</span>
      </header>

      <div class="timeline-line" style="opacity: 20%;"></div>
    </div>

  </div>
  </section>
</template>
<script>
  export default {
    name: "AboutMe",
  };
</script>

<style>

  #grayscale {
    filter: grayscale(100%);
  }

  p {
    color: #b5b5b5;
  }

  .about {
    margin-left: 5vw;  
  }

  .image{
    max-width: 18vw;
    height: auto;
    margin-right: 2vw;
  }

  .AboutMe {
    text-align: left;
    padding: 0%;
  }

  .aboutMargin {
    margin-left: 22%;
    margin-right: 22%;
  }

  .about p {
    width: 100%;
  }

  .section.is-large {
    padding: 0;
  }

  strong {
    color: #8354FD;
  }

  .timeline-container {
    padding-top: 1%;
    padding-bottom: 1%;
  }

  .timeline {
    position: relative;
    margin-left: 3vw;
  }

  .timeline-line {
    position: absolute;
    width: 2px;
    height: calc(100%);
    background-color: rgb(255, 255, 255);
    top: 0;
    left: 1.5vw;
    z-index: 0;
  }

  .tl-item {
    padding: 2rem;
  }

  .timeline-marker img {
    position: absolute;
    margin-top: calc(5%);
    margin-left: calc(4%);
    z-index: 3;
    width: 8%;
    height: auto;
  }

  .timeline-header {
    position: sticky;
    z-index: 5;
  }

  .topImgBox {
    width: auto;
    height: 16rem;
    overflow: hidden;
    margin-bottom: 3vw;
  }

  .topImgBox img {
    width: auto;
    height: auto;
    object-position: center;
  }

  .endtag {
    padding: 1.5vw;
    margin-top: auto;
  }

  #one {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/intro-bg.jpeg ) no-repeat center center;
    background-position-y: 10%;
    background-position-x: 92%;
    background-size: cover;
  }

  #two {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/summa.jpeg) no-repeat center center;
    background-position-y: 22%;
      background-size: cover;
  }

  #three {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/fontys.jpg) no-repeat center center;
    background-position-y: 50%;
    background-size: cover;
  }

  #four {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/philipsHTC.jpg) no-repeat center center;
    background-position-y: 22%;
    background-size: cover;
  }

  #five {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/p4b.jpg) no-repeat center center;
    background-position-y: 16%;
    background-size: cover;
  }

  #six {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/intro-bg.jpeg ) no-repeat center center;
    background-position-y: 10%;
    background-position-x: 92%;
    background-size: cover;
  }

  #seven {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/train.jpg) no-repeat center center;
    background-position-y: 32%;
    background-size: cover;
  }

  #eight {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/train.jpg) no-repeat center center;
    background-position-y: 32%;
    background-size: cover;
  }

  #nine {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/train.jpg) no-repeat center center;
    background-position-y: 32%;
    background-size: cover;
  }

  #ten {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/train.jpg) no-repeat center center;
    background-position-y: 32%;
  }

  #eleven {
    background: linear-gradient(to right, rgba(107, 77, 168, 0.85) 0%, rgba(73, 119, 194, 0.85) 60%), url(../assets/wf-building.jpg) no-repeat center center;
    background-position-y: 16%;
    background-size: cover;
  }

  .titleSmaller {
    color: #8354FD;
  }

  .topImgBox img {
      height: 3vw;
      width: auto;
    }

  @media only screen and (max-width: 1020px) {

    .aboutMargin {
      margin: auto;
    }

    .topImgBox img {
      height: 10vw;
      width: auto;
    }

  }

  @media only screen and (max-width: 768px) {
    
    .hero-body {
      margin-top: 10rem;
    }

    .timeline-container {
      padding-top: 10vw;
      padding-bottom: 10vw;
    }

    .topImgBox {
      width: auto;
      height: 8rem;
      overflow: hidden;
      margin-bottom: 3rem;
    }

    .about p {
      width: 110%;
    }

    .about {
      margin-left: 2vw;  
      width: auto;
    }

    .aboutMargin {
      margin: auto;
    }

    .miniTitle {
      margin-top: 4vw;
    }

    .topImgBox img {
      height: 10vw;
      width: auto;
    }

    
  }
</style>
